/* eslint-disable react/jsx-indent */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useFavorites, useUser } from '../../contexts/UserContext';
import FavoriteButton from '../buttons/Favorite';
import PlayButton from '../buttons/Play';
import Image from './Image';
import Video from './Video';

import styles from '../../../styles/partials/film-trailer.module.css';

const propTypes = {
    film: PropTypes.shape({ id: PropTypes.string }),
    inDocWeek: PropTypes.bool,
    withoutFavorites: PropTypes.bool,
    className: PropTypes.string,
};

function FilmTrailer({
    film = null,
    inDocWeek = false,
    withoutFavorites = false,
    className = null,
}) {
    const { id = null, image = null, trailer = null } = film || {};
    const user = useUser();

    const { hasFavorite, onChangeFavorite } = useFavorites();
    const isFavorite = hasFavorite(id);
    const onClickFavorite = useCallback(() => {
        onChangeFavorite(id);
    }, [id, onChangeFavorite]);

    const [showTrailer, setShowTrailer] = useState(false);
    const onClickPlay = useCallback(() => {
        if (trailer !== null) {
            setShowTrailer(!showTrailer);
        }
    }, [showTrailer, setShowTrailer, trailer]);

    useEffect(() => {
        setShowTrailer(false);
    }, [id, setShowTrailer]);

    return (
        <div
            className={classNames([
                styles.container,
                { [styles.showTrailer]: showTrailer, [className]: className !== null },
            ])}
        >
            {showTrailer ? (
                <Video className={styles.trailer} video={trailer} autoPlay />
            ) : (
                <Image
                    className={styles.image}
                    image={image}
                    withDocWeek={inDocWeek}
                    withDocLink={inDocWeek}
                    size="large"
                    filtered
                    rounded
                    header
                />
            )}
            <div className={styles.buttons}>
                {trailer !== null ? (
                    <PlayButton
                        className={classNames([styles.play, { [styles.active]: false }])}
                        withLabel
                        onClick={onClickPlay}
                    >
                        <FormattedMessage defaultMessage="Play the trailer" description="Button" />
                    </PlayButton>
                ) : null}
                {user !== null && !withoutFavorites ? (
                    <FavoriteButton
                        className={classNames([styles.favorite, { [styles.active]: isFavorite }])}
                        withLabel
                        onClick={onClickFavorite}
                    >
                        {isFavorite ? (
                            <FormattedMessage
                                defaultMessage="In your favorites"
                                description="Button"
                            />
                        ) : (
                            <FormattedMessage
                                defaultMessage="Add to favorites"
                                description="Button"
                            />
                        )}
                    </FavoriteButton>
                ) : null}
            </div>
        </div>
    );
}

FilmTrailer.propTypes = propTypes;

export default FilmTrailer;
